import React, { useMemo, useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import SearchInput from "../../components/SearchInput"; 
import { authFetch } from "../../utils/api";
import "../../styles/admin/aseguradoras.css"; 


export default function Estaciones() {
  const [q, setQ] = useState("");
  const [estaciones, setEstaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    setError(null);
    authFetch('/api/Estaciones')
      .then((res) => {
        if (!res.ok) {
          throw new Error('Error al cargar estaciones: ' + res.statusText);
        }
        return res.json();
      })
      .then((data) => {
        setEstaciones(data);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setEstaciones([]);
        setLoading(false);
      });
  }, []);

  const rows = useMemo(() => {
    const t = q.trim().toLowerCase();
    if (!t) return estaciones;

    return estaciones.filter(r =>
      r.nombre.toLowerCase().includes(t)
    );
  }, [q, estaciones]);

  const handleAgregar = () => {
    navigate('/admin/estaciones/agregar');
  };

  const handleEditar = (estacion) => {
    navigate(`/admin/estaciones/editar/${estacion.id}`);
  };

  const handleDelete = async (estacion) => {
    const confirmacion = window.confirm(
      `¿Estás seguro de que deseas eliminar la estación "${estacion.nombre}"?`
    );

    if (!confirmacion) return;

    try {
      const response = await authFetch(`/api/Estaciones/${estacion.id}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('No se pudo eliminar la estación.');
      }

      setEstaciones(prev => prev.filter(p => p.id !== estacion.id));
      alert('Estación eliminada exitosamente.');

    } catch (err) {
      alert(`Error: ${err.message}`);
    }
  };

  return (
    <main className="aseg-main">
      <header className="aseg-header">
        <h1 className="aseg-title">Estaciones Ferroviarias</h1>
        <button className="aseg-btn" onClick={handleAgregar}>
          Agregar Estación
        </button>
      </header>

      <SearchInput
        placeholder="Buscar estación por nombre"
        value={q}
        onChange={(e) => setQ(e.target.value)} 
      />

      {loading && <p>Cargando estaciones...</p>}
      {error && <p style={{ color: '#e11d48' }}>Error: {error}</p>}

      {!loading && !error && (
        <div className="aseg-card">
          <div className="aseg-table-wrapper">
            <table className="aseg-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Latitud</th>
                  <th>Longitud</th>
                  <th className="col-acciones">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map(r => (
                    <tr key={r.id}>
                      <td>{r.nombre}</td>
                      <td>{r.latitud}</td>
                      <td>{r.longitud}</td>
                      <td className="td-acciones">
                        <button
                          type="button"
                          className="aseg-link"
                          onClick={() => handleEditar(r)}
                        >
                          Editar
                        </button>
                        <button
                          type="button"
                          className="aseg-link"
                          style={{ marginLeft: '8px' }}
                          onClick={() => handleDelete(r)}
                        >
                          Borrar
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="aseg-empty">
                      No se encontraron estaciones.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </main>
  );
}